module.exports = __webpack_public_path__ + "media/images/icons/flags/ME-1b374e9803b0bc72f5cec3abd57db5dd.svg";